export const generationExitConfirmCopy = {
  title: "Content generation will continue in the background",
  description:
    "Your content generation will continue in the background. Once completed, it will be saved to your Library.",
  continueLabel: "Continue",
  doNotSaveLabel: "Do Not Save",
  activeToolSuffix: "is generating content right now.",
};

export const generationCompletionCopy = {
  title: "Generation Complete",
  description:
    "Your content has been successfully generated and is ready to view.",
  viewContentLabel: "View Content",
  goToLibraryLabel: "Go to Library",
  saveLabel: "Save",
};

export const unsavedChangesConfirmCopy = {
  title: "Unsaved changes",
  description: "Your changes will be lost if you leave this page.",
  stayLabel: "Stay on Page",
  leaveLabel: "Continue",
};

export function getGenerationExitConfirmCopy(variant = "generating") {
  return variant === "unsaved"
    ? unsavedChangesConfirmCopy
    : generationExitConfirmCopy;
}
